<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense dark elevation="0" color="primary">
                    <v-list-item-title>
                        <!-- <v-icon>mdi-eye-circle</v-icon> -->
                        <span>採苗</span>
                    </v-list-item-title>
                    <TitleButton
                        icon="mdi-floppy"
                        name="採苗"
                        @click="onClickSave()" />
                    <TitleButton
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-form ref="form">
                        <v-row >
                            <v-col>
                                <DatePicker 
                                    label="作業日"
                                    v-model="editItems.date"
                                    dense />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <!-- <v-text-field 
                                    v-model="editItems.num" 
                                    clearable 
                                    label="採苗数" 
                                    outlined 
                                    type="number" 
                                    suffix="苗" 
                                    prepend-icon="mdi-sprout" 
                                    dense /> -->
                                <NumInput 
                                    v-model="editItems.num" 
                                    clearable
                                    suffix="苗"
                                    label="採苗数" 
                                    outlined
                                    hide-details 
                                    dense
                                    align="align-left" />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <v-tooltip bottom color="teal lighten-4 black--text">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="editItems.name" 
                                            clearable 
                                            label="苗の名前" 
                                            type="text"
                                            dense
                                            outlined
                                            hide-details />
                                    </template>
                                    <span v-if="editItems.name == null || editItems.name == ''">
                                        何も入力されていない時は、システムが自動で命名します。
                                    </span>
                                    <span v-else>
                                        名前の中に @ を含めると<br/>
                                        それが連番になります。<br/>
                                        例えば、採苗数=10, 開始=1 で 名前に "苗_@" と入力すると<br/>
                                        苗_1～苗_10 が作成されます。
                                    </span>
                                </v-tooltip>
                            </v-col>
                            <v-col >
                                <NumInput 
                                    v-if="editItems.name != null && editItems.name != ''"
                                    v-model="editItems.seqStartNo" 
                                    clearable
                                    label="連番の開始番号"
                                    outlined
                                    hide-details 
                                    type="text" 
                                    dense
                                    align="align-left" />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.memo" 
                                    clearable 
                                    label="メモ" 
                                    outlined 
                                    type="text" 
                                    counter="50"
                                    :rules="[validatorMemoLength]" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import DatePicker from '@/components/tools/DatePicker';
    import TitleButton from '@/components/tools/TitleBarButton';
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            DatePicker,
            TitleButton,
            NumInput,
            Confirm
        },
        data: function () {
            return {
                isView: false,
                targetSeedling: null,
                editItems: {
                    date: this.df_currentDateTime("yyyy-MM-dd"),
                    num: 0,
                    memo: "",
                    name: null,
                    seqStartNo: 1
                },
                validatorMemoLength: value => value.length <= 50 || '50文字以内で入力して下さい。',
            }
        },
        methods: {
            onClickSave: function () {
                const userUID = this.$store.getters["userUID"]
                const self = this
                this.$refs.confirm.show({
                    title: "苗",
                    message: "採苗しますか？",
                    buttonYes: "採苗する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        db.collection("users").doc(userUID).collection("managements").doc("seedling").collection("days").doc(self.editItems.date).get().then(function(doc){
                            var managementData = doc.data()
                            self.register(managementData)
                        })
                        return true
                    },
                })
            },
            register: function (managementData) {
                console.log("register", managementData, this.editItems)

                const userUID = this.$store.getters["userUID"]
                const self = this

                // 管理データが存在しない時は、新規に作成
                if (managementData == null) {
                    managementData = {
                        date: this.editItems.date,
                        varieties: []
                    }
                }

                // 管理データから、選択された品種のデータを取得
                // 存在しない時は、新規に作成
                var varietyManagementData = null        
                if (managementData != null) {
                    const index = managementData.varieties.findIndex((v)=>v.cropID == this.targetSeedling.variety.cropID && v.varietyID == this.targetSeedling.variety.varietyID)
                    
                    var isNewManagementData
                    if (index < 0) {
                        varietyManagementData = {
                            cropID: this.targetSeedling.variety.cropID,
                            varietyID: this.targetSeedling.variety.varietyID,
                            lastSeqNo: 0
                        }
                        managementData.varieties.push(varietyManagementData)
                    } else {
                        varietyManagementData = managementData.varieties[index]
                    }
                }

                // 登録処理開始
                try {
                    var registeredSeedlings = []
                    var batch = db.batch()
                    // 子苗
                    for (var i=1; i<=this.editItems.num; i++) {
                        const seqNo = varietyManagementData.lastSeqNo + i
                        const id = this.editItems.date + "-" + ("000" + this.targetSeedling.variety.cropID).slice(-3) + "-" + ("000" + this.targetSeedling.variety.varietyID).slice(-3) + "-" + ("000" + seqNo).slice(-3)
                        const customNameSeqNo = (this.editItems.seqStartNo * 1) + i - 1
                        const customName = this.editItems.name == null || this.editItems.name == "" ? id : this.editItems.name.replace("@", customNameSeqNo+"")

                        const seedling = {
                            varsion: "1.0.0",
                            seedlingID: id,
                            name: customName,
                            parentSeedling: {
                                seedlingID: this.targetSeedling.seedlingID,
                                place: this.targetSeedling.currentPlace,
                                date: this.targetSeedling.placeHistories[this.targetSeedling.placeHistories.length - 1].date
                            },
                            generationNo: this.targetSeedling.generationNo + 1,
                            childNo: i,
                            variety: {
                                cropID: this.targetSeedling.variety.cropID,
                                varietyID: this.targetSeedling.variety.varietyID,
                            },
                            state: 1,
                            currentPlace: this.targetSeedling.currentPlace,
                            placeHistories: [
                                {
                                    type: 1,
                                    place: this.targetSeedling.currentPlace,
                                    date: this.editItems.date,
                                    dateTime: this.df_currentDateTime(),
                                    userUID: userUID,
                                }
                            ],
                            childNum: 0,
                            results: {
                                harvestedNum: 0,
                                observatedNum: 0,
                                workedNum: 0,
                                seedling: {
                                    userUID: userUID,
                                    startDate: this.editItems.date,
                                    place: this.targetSeedling.currentPlace,
                                },
                                planting: {
                                    userUID: "",
                                    startDate: "",
                                    place: ""
                                }
                            },
                            memo: this.editItems.memo,
                            register: {
                                userUID: userUID,
                                dateTime: this.df_currentDateTime()
                            },
                            updater: {
                                userUID: "",
                                dateTime: ""
                            }
                        }
                        registeredSeedlings.push(seedling)
                        batch.set(db.collection("users").doc(userUID).collection("seedlings").doc(seedling.seedlingID), seedling)
                    }
                    // 親苗
                    this.targetSeedling.childNum += (this.editItems.num * 1)
                    batch.update(
                        db.collection("users").doc(userUID).collection("seedlings").doc(this.targetSeedling.seedlingID), 
                        {
                            "childNum": this.targetSeedling.childNum,
                            "updater": {
                                userUID: userUID,
                                dateTime: this.df_currentDateTime()
                            }
                        }
                    )
                    // 管理データ
                    varietyManagementData.lastSeqNo += (this.editItems.num * 1)
                    batch.set(db.collection("users").doc(userUID).collection("managements").doc("seedling").collection("days").doc(this.editItems.date), managementData)

                    // コミット
                    batch.commit().then(function(){
                        self.$store.commit("notification", {message:"苗を登録しました。"})
                        self.$emit("onRegisteredSeedlings", registeredSeedlings)
                        self.isView = false
                    }).catch(function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"苗の登録に失敗しました。", isError:true})
                    })
                } catch (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"苗の登録に失敗しました。", isError:true})
                }
            },
            show: function (seedling) {
                this.targetSeedling = seedling
                if (seedling.seedlingID == seedling.name) {
                    this.editItems.name = null
                } else {
                    this.editItems.name = this.targetSeedling.name
                }
                this.editItems.seqStartNo = 1
                this.isView = true
            }
        }
    }
</script>
